module.exports = __webpack_public_path__ + "auth0.8d3ad5.svg";